var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-content-back"},[_c('SearchContainer',{attrs:{"add-tag-to-query":true,"auto-redirect":true,"selected-youth":_vm.selectedYouth},on:{"selectedYouth":_vm.youthChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }